import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleCrypt } from 'ngx-simple-crypt';
import { ToastrService } from 'ngx-toastr';
import { TemplatesService } from 'src/app/services/templates.service';
import { environment } from 'src/environments/environment';
import { Location } from "@angular/common";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modal-adicionar-template',
  templateUrl: './modal-adicionar-template.component.html',
  styleUrls: ['./modal-adicionar-template.component.scss']
})
export class ModalAdicionarTemplateComponent implements OnInit, OnDestroy {
  @Input() tipoTemplate;
  @Input() chamado_id;
  conteudo_template;
  rotas;
  tipo;
  assunto;
  selector: string;
  newSubs: Subscription;

  constructor(
    public modal: NgbActiveModal,
    private router: ActivatedRoute,
    private templatesService: TemplatesService,
    private toastr: ToastrService,
    private location: Location,
    private elemRef: ElementRef,
  ) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
    //this.rotas = this.router.snapshot['_routerState'].url.split("/");
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85'
    if (this.tipoTemplate && this.tipoTemplate.tipo) {
      this.tipo = this.tipoTemplate.tipo;
    } else {
      this.tipo = this.tipoTemplate;
    }
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false;
    }
    return true;
  }

  insereTemplate(template): void {
    if(template) {
      this.assunto = template.assunto ? template.assunto : (this.conteudo_template = '');
      if (template.id) {
        this.newSubs = this.templatesService.traduzirTemplate(template.id, this.chamado_id)
          .subscribe(results => {      
            this.conteudo_template = results;
          }, (error) => console.error('insereTemplate', error))      
      }
    }
  }

  adicionarTemplate(template): void {
    if (this.assunto && template) {
      var content;
      content = { assuntoEmail: this.assunto, template: this.tratamentoDarkMode(template), assunto: this.assunto };        
      this.modal.close(content);
    } else if (!this.assunto && template) {
      var content;
      content = { template: this.tratamentoDarkMode(template) };
      this.modal.close(content);
    } else {
      this.modal.close();
    }

  }

  tratamentoDarkMode(htmlTemplate) {
    if (localStorage.getItem('theme') === 'dark') {

      //var _aux = htmlTemplate.toString().replace('color: rgb(34, 34, 34);', 'color: rgb(255, 255, 255);').replace('background-color: rgb(255, 255, 255);', 'background-color: rgb(34, 34, 34);');
      var str = htmlTemplate
      const regex = /(style=".+?")/gm;
      const subst = ``;
      const result = str.replace(regex, subst);

      return result;
    }
    return htmlTemplate;
  }
}
